// the type of workers
export const workers_category = [
    "all",
    "assistant",
    "secretory",
    "technician",
    "health educator",
    "hygienist",
    "mechanics",
];